import * as Phaser from 'phaser';
import { TIER_COLORS, powerupFrame } from '@rttv/shared';
import type { PowerupTier, PowerupType } from '@rttv/shared';

interface PowerupLike {
  type: string;
  tier: string;
  x: number;
  y: number;
  ttl: number;
}

export class PowerupSprite {
  readonly sprite: Phaser.GameObjects.Image;
  private readonly glow: Phaser.GameObjects.Arc;
  private readonly worldX: number;
  private readonly worldY: number;
  private readonly bobPhase: number;
  private readonly spawnTime: number;
  private readonly initialTtl: number;

  constructor(scene: Phaser.Scene, state: PowerupLike) {
    this.worldX    = state.x;
    this.worldY    = state.y;
    this.bobPhase  = Math.random() * Math.PI * 2;
    this.spawnTime = Date.now();
    this.initialTtl = state.ttl;

    const color = TIER_COLORS[state.tier as PowerupTier] ?? 0xffffff;
    const frame = powerupFrame(state.tier as PowerupTier, state.type as PowerupType);

    this.glow = scene.add
      .circle(state.x, state.y, 28, color, 0.3)
      .setDepth(9);

    this.sprite = scene.add
      .image(state.x, state.y, 'sheet', frame)
      .setDepth(10);
  }

  update(time: number) {
    const elapsed   = (Date.now() - this.spawnTime) / 1000;
    const remaining = Math.max(0, this.initialTtl - elapsed);
    const fade      = Math.min(1, remaining / 5);

    const bob   = Math.sin(time / 500 + this.bobPhase) * 5;
    const pulse = 0.4 + 0.35 * Math.sin(time / 350 + this.bobPhase);

    this.sprite.setPosition(this.worldX, this.worldY + bob);
    this.glow.setPosition(this.worldX, this.worldY + bob);
    this.glow.setAlpha(pulse * fade);
    this.sprite.setAlpha(fade < 1 ? fade : 1);
  }

  destroy() {
    this.sprite.destroy();
    this.glow.destroy();
  }
}
